import { Record, List } from "immutable";

export class StageRecord extends Record({
    id: null,
    stage_name: null,
    users: new List([])
}) {
    constructor(props) {
        super(props);
        this.set("users", new List(props.users));
    }
}
